var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverSolution3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5441 55.0767L34.3988 64.2363C37.2438 65.8799 40.7499 65.8799 43.5949 64.2363L59.4496 55.0767C61.6416 53.8103 62.9917 51.471 62.9917 48.9395V24.4502L62.629 24.867C61.8763 25.732 60.9853 26.4663 59.9924 27.0399Lnan nanL59.9924 27.0399L56.993 28.7727L50.9943 32.2383L42.9381 36.8926C40.4995 38.3014 37.4943 38.3014 35.0556 36.8926L26.9994 32.2383L21.0007 28.7727L18.0013 27.0399Lnan nanL18.0013 27.0399C17.0083 26.4663 16.1169 25.7326 15.3628 24.8686L15.002 24.4551L15.002 48.9396C15.002 51.471 16.3521 53.8103 18.5441 55.0767Z",
    fill: "url(#paint0_linear_2137_19420)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5441 55.0767L34.3988 64.2363C37.2438 65.8799 40.7499 65.8799 43.5949 64.2363L59.4496 55.0767C61.6416 53.8103 62.9917 51.471 62.9917 48.9395V24.4502L62.629 24.867C61.8763 25.732 60.9853 26.4663 59.9924 27.0399Lnan nanL59.9924 27.0399L56.993 28.7727L50.9943 32.2383L42.9381 36.8926C40.4995 38.3014 37.4943 38.3014 35.0556 36.8926L26.9994 32.2383L21.0007 28.7727L18.0013 27.0399Lnan nanL18.0013 27.0399C17.0083 26.4663 16.1169 25.7326 15.3628 24.8686L15.002 24.4551L15.002 48.9396C15.002 51.471 16.3521 53.8103 18.5441 55.0767Z",
    fill: "url(#paint1_linear_2137_19420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9352 37.383C40.4967 38.7917 37.4916 38.7916 35.0531 37.3828L16.2578 26.5243C14.5078 25.5133 14.5078 22.9873 16.2578 21.9763L35.0527 11.1181C37.4914 9.70921 40.4968 9.70928 42.9355 11.1183L61.7306 21.9779C63.4805 22.989 63.4804 25.515 61.7304 26.5259L42.9352 37.383Z",
    fill: "url(#paint2_linear_2137_19420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9063 27.3892C45.9063 28.9765 44.6195 30.2632 43.0322 30.2632C41.445 30.2632 40.1582 28.9765 40.1582 27.3892C40.1582 25.8019 41.445 24.5151 43.0322 24.5151C44.6195 24.5151 45.9063 25.8019 45.9063 27.3892Z",
    fill: "url(#paint3_linear_2137_19420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9063 27.3892C45.9063 28.9765 44.6195 30.2632 43.0322 30.2632C41.445 30.2632 40.1582 28.9765 40.1582 27.3892C40.1582 25.8019 41.445 24.5151 43.0322 24.5151C44.6195 24.5151 45.9063 25.8019 45.9063 27.3892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3363 37.7658C57.3363 47.9001 49.1208 56.1156 38.9865 56.1156C28.8522 56.1156 20.6367 47.9001 20.6367 37.7658C20.6367 27.6315 28.8522 19.416 38.9865 19.416C49.1208 19.416 57.3363 27.6315 57.3363 37.7658Z",
    fill: "url(#paint4_linear_2137_19420)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8955 28.9949C51.2459 28.0411 49.913 28.047 48.9607 28.6988C47.701 29.561 46.3492 30.0084 45.0819 29.7138C42.8947 29.2053 41.4565 26.6021 40.8402 23.8148C40.6397 22.9081 39.9201 22.1646 38.9915 22.1646V22.1646C30.3754 22.1646 23.3906 29.1493 23.3906 37.7654C23.3906 39.836 23.794 41.8123 24.5264 43.6201C24.7086 44.0699 25.1768 44.3181 25.6621 44.3181V44.3181C26.3893 44.3181 26.6357 41.9168 26.8884 39.4546C26.9359 38.9921 26.9835 38.5274 27.0347 38.0761C27.2152 36.4828 28.517 36.5247 29.2951 37.9267C31.0045 41.0066 32.2079 38.9606 32.8124 37.9329C33.1064 37.4332 33.2587 37.1742 33.2587 37.8624C33.2587 39.7611 32.3297 44.7782 30.9262 49.3503C30.6587 50.2216 30.9779 51.1847 31.7859 51.6062C33.9413 52.7306 36.3922 53.3663 38.9915 53.3663C44.8401 53.3663 49.9371 50.148 52.6079 45.3856C52.6343 45.3386 52.5951 45.2821 52.5418 45.2899V45.2899C48.0939 45.947 42.6805 46.7466 42.6805 43.9832C42.6805 43.387 43.5692 42.793 44.525 42.1542C45.8338 41.2795 47.2683 40.3207 46.7187 39.1572C46.1213 37.8924 45.5924 36.4008 46.7448 35.6078C48.2539 34.5693 50.0204 33.5704 51.6774 32.766C52.6613 32.2884 53.1569 31.1289 52.624 30.1739C52.3983 29.7695 52.1551 29.3762 51.8955 28.9949Z",
    fill: "url(#paint5_linear_2137_19420)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.272 37.832C50.249 37.9231 50.2397 38.0175 50.2507 38.1108C50.3729 39.1543 51.2364 40.519 52.4716 42.0965C52.9408 42.6957 53.8688 42.5375 54.0653 41.8022C54.4092 40.5146 54.5925 39.1615 54.5925 37.7655C54.5925 36.6187 54.4688 35.5007 54.2339 34.4243C54.095 33.7875 53.3636 33.5082 52.8547 33.9154C51.6003 34.919 50.684 36.2014 50.272 37.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.272 37.832C50.249 37.9231 50.2397 38.0175 50.2507 38.1108C50.3729 39.1543 51.2364 40.519 52.4716 42.0965C52.9408 42.6957 53.8688 42.5375 54.0653 41.8022C54.4092 40.5146 54.5925 39.1615 54.5925 37.7655C54.5925 36.6187 54.4688 35.5007 54.2339 34.4243C54.095 33.7875 53.3636 33.5082 52.8547 33.9154C51.6003 34.919 50.684 36.2014 50.272 37.832Z",
    fill: "url(#paint6_linear_2137_19420)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19420",
    x1: 38.9968,
    y1: 24.4502,
    x2: 38.9968,
    y2: 65.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19420",
    x1: 38.9969,
    y1: 25.7775,
    x2: 45.2812,
    y2: 52.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19D78B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#227AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19420",
    x1: 38.9941,
    y1: 10.0615,
    x2: 38.9941,
    y2: 38.4395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19D78B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19420",
    x1: 43.0322,
    y1: 24.7011,
    x2: 44.0436,
    y2: 28.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19D78B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19420",
    x1: 38.9865,
    y1: 20.6036,
    x2: 45.4435,
    y2: 44.4377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19D78B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2137_19420",
    x1: 38.1161,
    y1: 22.1646,
    x2: 38.1161,
    y2: 53.3663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CE400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2137_19420",
    x1: 52.4193,
    y1: 33.7246,
    x2: 52.4193,
    y2: 42.4641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CE400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverSolution3);
export default __webpack_public_path__ + "static/media/naverSolution3.dad3fcb6acb3b0898ab7f4538d3336f3.svg";
export { ForwardRef as ReactComponent };